<div id="capture_signature_div">
  <!-- sign with Wacom device [hidden by default] -->
  <div class="with-wacom" [hidden]="true">
    <p>
      Selected STU device: <span #selectedStuDevice></span>-<button name="removeDevice" (click)="removeDevice()">Remove</button><br>
      <button #capture_stu_btn (click)="capture('STU')" disabled="disabled">Capture signature from STU
        tablet</button><br><br>
    </p>
  </div>
  <!-- sign with mouse [hidden by default] -->
  <div class="without-wacom" [hidden]="true">
    <p>The input data for the signature can be taken from different sources:</p>
    <fieldset style="width:400px; height:40px; padding:5px; margin:5px;">
      <legend>Input sources</legend>
      <input type="checkbox" name="allow_mouse_check" #allow_mouse_check checked="checked">
      <label for="allow_mouse_check">Allow mouse</label>
      <input type="checkbox" name="allow_touch_check" #allow_touch_check checked="checked">
      <label for="allow_touch_check">Allow touch</label>
      <input type="checkbox" name="allow_pen_check" #allow_pen_check checked="checked">
      <label for="allow_pen_check">Allow pen</label>
    </fieldset>
    <button #capture_canvas_btn (click)="capture('Canvas')" disabled="disabled">Capture signature from Generic device</button>
  </div>
  <!-- signature canvas -->
  <div class="signature">
    <label [htmlFor]="label" [innerHTML]="label" class="input-label"></label>
    <fieldset style="width:0;padding:0;margin:0;">
      <div #captureDiv id="captureDiv" style="width:400px;height:200px;position:relative;overflow:hidden;"></div>
      <img #signatureImage style="display:none">
    </fieldset>
    <p [hidden]="true">
      <button #save_image_btn (click)="saveSignature('image')" disabled="disabled">Save as
        Image</button>&nbsp;&nbsp;
      <button #save_text_btn (click)="saveSignature('txt')" disabled="disabled">Save as Text</button>&nbsp;&nbsp;
      <button #save_binary_btn (click)="saveSignature('binary')" disabled="disabled">Save as Binary</button>&nbsp;&nbsp;
      <button #save_iso_btn (click)="saveSignature('iso')" disabled="disabled">Save as ISO</button>&nbsp;&nbsp;
    </p>
  </div>
</div>

<!-- SIGNATURE SETTINGS [hidden by default] -->
<!-- in case we want to change signature config (color, width and so on) -->
<div id="settings_div" [hidden]="true">
  <div>
    <fieldset style="width:400px;padding:5px;margin:5px">
      <legend>STU Settings</legend>
      <input type="checkbox" name="encrypt_stu" #encrypt_stu checked="checked">
      <label for="encrypt_stu">Encrypt STU communication</label>
    </fieldset>
  </div>
  <div>
    <fieldset style="width:400px;padding:5px;margin:5px">
      <legend>Ink</legend>
      <label for="ink_width">Ink width:</label>
      <input type="number" name="ink_width" #ink_width value="6">
      <br><br>
      <label for="rendering_color_box">Ink color:</label>
      <input type="color" name="rendering_color_box" #rendering_color_box value="#000000">
      <br>
      <label for="background_color_box">Background color</label>
      <input type="color" name="background_color_box" #background_color_box value="#ffffff">
      <br>
      <input type="checkbox" name="put_background_image" #put_background_image>
      <label for="background_image">Use background image</label><br>
      <input type="file" #background_image name="background_image" (change)="loadBackgroundImage()"
        accept="image/*">
      <br>
      <label for="background_image_mode">Background image mode</label><br>
      <select name="background_image_mode" #background_image_mode>
        <option value="none">None</option>
        <option value="fit" selected="selected">Fit</option>
        <option value="center">Center</option>
        <option value="pattern">Pattern</option>
      </select>
      <br>
      <label for="background_opacity">Background opacity</label>
      <input type="range" min="1" max="100" value="100" #background_opacity>
      <br>
      <input type="checkbox" name="allowOutSide" #allowOutSide checked="checked">
      <label for="allowOutSide">Allow outside inking</label><br>
      <input type="checkbox" name="allowZeroPressure" #allowZeroPressure checked="checked">
      <label for="allowZeroPressure">Allow zero pressure</label><br>
    </fieldset>
  </div>
  <div>
    <fieldset style="width:400px;padding:5px;margin:5px">
      <legend>Capture window</legend>
      <label for="dialog_width">Width:</label>
      <input type="input" name="dialog_width" #dialog_width value="400">
      <br>
      <label for="dialog_height">Height:</label>
      <input type="input" name="dialog_height" #dialog_height value="300">
      <br>
      <label for="stu_fit_mode">Size mode:</label>
      <select name="stu_fit_mode" #stu_fit_mode>
        <option value="fixed">The values defined in Width and Height</option>
        <option value="fit">Fit to parent div</option>
        <option value="strech">Strech to parent div maintaining proportion</option>
        <option value="stu">STU dimensions</option>
      </select>
      <br>
      <input type="checkbox" name="shows_modal" #shows_modal checked="checked">
      <label for="shows_modal">Set as modal</label>
      <br>
      <input type="checkbox" name="shows_as_dialog" #shows_as_dialog>
      <label for="shows_as_dialog">Shows as dialog</label>
      <br>
      <fieldset>
        <label for="dialog_left">Left:</label>
        <input type="input" name="dialog_left" #dialog_left value="0">
        <br>
        <label for="dialog_top">Top:</label>
        <input type="input" name="dialog_top" #dialog_top value="0">
        <br>
        <input type="checkbox" name="is_centered" #is_centered checked="checked">
        <label for="is_centered">Set as centered</label>
        <br>
        <input type="checkbox" name="is_draggable" #is_draggable checked="checked">
        <label for="is_draggable">Set as draggable</label>
        <br>
        <label for="border_color_box">Border color</label>
        <input type="color" name="border_color_box" #border_color_box value="#0097d4">
        <br>
        <label for="border_width_box">Border width</label>
        <input type="text" name="border_width_box" #border_width_box value="3">
        <br>
        <input type="checkbox" name="has_title_check" #has_title_check checked="checked">
        <label for="has_title_check">Has title</label>
        <br>
        <label for="title_text">Title text</label>
        <input type="text" name="title_text" #title_text value="Capture signature">
      </fieldset>
      <fieldset>
        <legend>Signatory</legend>
        <div>
          <p>
            <input type="checkbox" name="show_signatory_check" #show_signatory_check>
            <label for="show_signatory_check">Show signatory</label>
          </p>
          <p>
            <label for="signatory_font_type_text">Font type: </label>
            <input type="text" name="signatory_font_type_text" #signatory_font_type_text value="roboto-regular">
            <br>
            <label for="signatory_font_size_text">Font size: </label>
            <input type="text" name="signatory_font_size_text" #signatory_font_size_text value="14">
          </p>
          <p>
            <label for="signatory_offset_x_text">Offset x: </label>
            <input type="text" name="signatory_offset_x_text" #signatory_offset_x_text value="30">
            <br>
            <label for="signatory_offset_y_text">Offset y: </label>
            <input type="text" name="signatory_offset_y_text" #signatory_offset_y_text value="5">
          </p>
          <p>
            <label for="signatory_color_box">Text color</label>
            <input type="color" name="signatory_color_box" #signatory_color_box value="#1d1d1b">
          </p>
        </div>
      </fieldset>
      <fieldset>
        <legend>Reason</legend>
        <div>
          <p>
            <input type="checkbox" name="show_reason_check" #show_reason_check>
            <label for="show_reason_check">Show reason</label>
          </p>
          <p>
            <label for="reason_font_type_text">Font type: </label>
            <input type="text" name="reason_font_type_text" #reason_font_type_text value="roboto-regular">
            <br>
            <label for="reason_font_size_text">Font size: </label>
            <input type="text" name="reason_font_size_text" #reason_font_size_text value="14">
          </p>
          <p>
            <label for="reason_offset_x_text">Offset x: </label>
            <input type="text" name="reason_offset_x_text" #reason_offset_x_text value="5">
            <br>
            <label for="reason_offset_y_text">Offset y: </label>
            <input type="text" name="reason_offset_y_text" #reason_offset_y_text value="10">
          </p>
          <p>
            <label for="reason_color_box">Text color</label>
            <input type="color" name="reason_color_box" #reason_color_box value="#1d1d1b">
          </p>
        </div>
      </fieldset>
      <fieldset>
        <legend>Date</legend>
        <div>
          <p>
            <input type="checkbox" name="show_date_check" #show_date_check checked="checked">
            <label for="show_date_check">Show date</label>
          </p>
          <p>
            <label for="date_font_type_text">Font type: </label>
            <input type="text" name="date_font_type_text" #date_font_type_text value="roboto-regular">
            <br>
            <label for="date_font_size_text">Font size: </label>
            <input type="text" name="date_font_size_text" #date_font_size_text value="14">
          </p>
          <p>
            <label for="date_offset_x_text">Offset x: </label>
            <input type="text" name="date_offset_x_text" #date_offset_x_text value="30">
            <br>
            <label for="date_offset_y_text">Offset y: </label>
            <input type="text" name="date_offset_y_text" #date_offset_y_text value="20">
          </p>
          <p>
            <label for="date_color_box">Text color</label>
            <input type="color" name="date_color_box" #date_color_box value="#1d1d1b">
          </p>
        </div>
      </fieldset>
      <fieldset>
        <legend>Signing line</legend>
        <div>
          <p>
            <input type="checkbox" name="show_signing_line_check" #show_signing_line_check checked="checked">
            <label for="show_signing_line_check">Show signing line</label>
          </p>
          <p>
            <label for="signing_line_left_text">Left: </label>
            <input type="text" name="signing_line_left_text" #signing_line_left_text value="30">
            <br>
            <label for="signing_line_right_text">Right: </label>
            <input type="text" name="signing_line_right_text" #signing_line_right_text value="30">
          </p>
          <p>
            <label for="signing_line_width_text">Width: </label>
            <input type="text" name="signing_line_width_text" #signing_line_width_text value="2">
            <br>
            <label for="signing_line_offset_y_text">Offset y: </label>
            <input type="text" name="signing_line_offset_y_text" #signing_line_offset_y_text value="5">
          </p>
          <p>
            <label for="signing_line_color_box">Text color</label>
            <input type="color" name="signing_line_color_box" #signing_line_color_box value="#c2a383">
          </p>
        </div>
      </fieldset>
      <fieldset>
        <legend>Buttons</legend>
        <p>
          <label for="button_font_type">Font type:</label>
          <input type="text" name="button_font_type" #button_font_type value="roboto-regular">
        </p>
        <div #button_list_div>
          <fieldset #clear_btn_div_default>
            <p>
              <label for="button_text">Button Text:</label>
              <input type="text" name="button_text" value="*clear">
            </p>
            <p>
              <label for="button_action">Action:</label>
              <input type="text" name="button_action" value="clear">
            </p>
            <p>
              <label for="button_text_color">Text color:</label>
              <input type="color" name="button_text_color" value="#1d1d1b">
            </p>
            <p>
              <label for="button_background_color">Background color:</label>
              <input type="color" name="button_background_color" value="#e8dfd6">
            </p>
            <p>
              <label for="button_border_width">Border width:</label>
              <input type="text" name="button_border_width" value="1">
            </p>
            <p>
              <label for="button_border_color">Border color:</label>
              <input type="color" name="button_border_color" value="#c2a383">
            </p>
          </fieldset>
          <!-- <fieldset #cancel_btn_div_default>
            <p>
              <label for="button_text">Button Text:</label>
              <input type="text" name="button_text" value="*cancel">
            </p>
            <p>
              <label for="button_action">Action:</label>
              <input type="text" name="button_action" value="cancel">
            </p>
            <p>
              <label for="button_text_color">Text color:</label>
              <input type="color" name="button_text_color" value="#1d1d1b">
            </p>
            <p>
              <label for="button_background_color">Background color:</label>
              <input type="color" name="button_background_color" value="#e8dfd6">
            </p>
            <p>
              <label for="button_border_width">Border width:</label>
              <input type="text" name="button_border_width" value="1">
            </p>
            <p>
              <label for="button_border_color">Border color:</label>
              <input type="color" name="button_border_color" value="#c2a383">
            </p>
          </fieldset> -->
          <fieldset #accept_btn_div_default>
            <p>
              <label for="button_text">Button Text:</label>
              <input type="text" name="button_text" value="*ok">
            </p>
            <p>
              <label for="button_action">Action:</label>
              <input type="text" name="button_action" value="accept">
            </p>
            <p>
              <label for="button_text_color">Text color:</label>
              <input type="color" name="button_text_color" value="#1d1d1b">
            </p>
            <p>
              <label for="button_background_color">Background color:</label>
              <input type="color" name="button_background_color" value="#e8dfd6">
            </p>
            <p>
              <label for="button_border_width">Border width:</label>
              <input type="text" name="button_border_width" value="1">
            </p>
            <p>
              <label for="button_border_color">Border color:</label>
              <input type="color" name="button_border_color" value="#c2a383">
            </p>
          </fieldset>
        </div>
      </fieldset>
    </fieldset>
    <fieldset style="width:400px;padding:5px;margin:5px">
      <legend>Render</legend>
      <p>
        In order to determinate the size of the image, if none of the width and height are defined it will render
        the signature with its real size. If only one value, width or height is defined, it will render maintaining
        the proportion
        rescpect with the entered value. If defined both values it will render with the defined dimensions.
      </p>
      <p>
        <label for="render_width">Width:</label>
        <input type="input" name="render_width" #render_width value="400"> px
      </p>
      <p>
        <label for="render_height">Height:</label>
        <input type="input" name="render_height" #render_height value="200"> px
      </p>
      <p>
        If render relative both dimensions Width and Height, should be equals. In case the two of them are provided
        the Height will be ignored.
        <br>
        <input type="checkbox" name="is_relative" #is_relative>
        <label for="is_relative">Set as relative</label>
      </p>
    </fieldset>
  </div>
  <div>
    <fieldset style="width:400px;padding:5px;margin:5px">
      <legend>Encryption</legend>
      <div>
        <input type="radio" #no_encryption name="encryption_group" value="none" checked="checked">
        <label for="no_encryption">Without Encryption</label>
      </div>
      <div>
        <input type="radio" #symmetric_encryption name="encryption_group" value="symmetric">
        <label for="symmetric_encryption">Symmetric encryption</label>
        <br>
        <label for="symmetric_password" style="padding-left:40px">Password: </label>
        <input type="password" #symmetric_password>
      </div>
      <div>
        <input type="radio" #asymmetric_encryption name="encryption_group" value="asymmetric_encryption">
        <label for="asymmetric_encryption">Asymmetric encryption</label>
        <br>
        <label for="public_key" style="padding-left:40px">Public Key (used for encryption):</label>
        <br>
        <textarea name="public_key" #public_key style="margin-left:40px"></textarea>
        <br>
        <span style="padding-left:30px">Private key (used for decryption):</span>
        <br>
        <label for="private_key_password" style="padding-left:40px">Private key password: </label>
        <input type="password" #private_key_password>
        <br>
        <label for="private_key" style="padding-left:40px">Private key:</label>
        <br>
        <textarea name="private_key" #private_key style="margin-left:40px"></textarea>
      </div>
    </fieldset>
  </div>
  <div>
    <fieldset style="width:400px;padding:5px;margin:5px">
      <legend>ISO</legend>
      <div>
        <label for="iso_type">Save ISO as:</label>
        <select name="iso_type" #iso_type>
          <option value="ISO19794_7_2007_BINARY">ISO19794_7_2007_BINARY</option>
          <option value="ISO19785_3_2015_XML">ISO19785_3_2015_XML</option>
          <option value="ISO19794_7_2007_ENCRYPTED_BINARY">ISO19794_7_2007_ENCRYPTED_BINARY</option>
          <option value="ISO19794_7_2007_ENCRYPTED_TEXT">ISO19794_7_2007_ENCRYPTED_TEXT</option>
          <option value="ISO19794_7_2014_BINARY">ISO19794_7_2014_BINARY</option>
          <option value="ISO19794_7_2014_ENCRYPTED_BINARY">ISO19794_7_2014_ENCRYPTED_BINARY</option>
          <option value="ISO19794_7_2014_ENCRYPTED_TEXT">ISO19794_7_2014_ENCRYPTED_TEXT</option>
          <option value="ISO19794_7_2021_BINARY">ISO19794_7_2021_BINARY</option>
          <option value="ISO19794_7_2021_ENCRYPTED_BINARY">ISO19794_7_2021_ENCRYPTED_BINARY</option>
          <option value="ISO19794_7_2021_ENCRYPTED_TEXT">ISO19794_7_2021_ENCRYPTED_TEXT</option>
        </select>
      </div>
    </fieldset>
  </div>
  <div>
    <fieldset style="width:400px;padding:5px;margin:5px">
      <legend>Time out</legend>
      <div>
        <input type="checkbox" name="enable_timeout" #enable_timeout checked="checked">
        <label for="enable_timeout">Enable time out</label>
        <br>
        <label for="timeOutValue">Time out value:</label>
        <input type="input" name="timeOutValue" #timeOutValue value="10000">
        <br>
        <label for="emptyTimeOut">Action when timeout without data</label>
        <select name="emptyTimeOut" #emptyTimeOut>
          <option value="cancel" selected="selected">Cancel</option>
        </select>
        <br>
        <label for="dataTimeOut">Action when timeout has data</label>
        <select name="dataTimeOut" #dataTimeOut>
          <option value="accept" selected="selected">Accept</option>
          <option value="cancel">Cancel</option>
        </select>
      </div>
    </fieldset>
    <fieldset style="width:400px;padding:5px;margin:5px">
      <legend>Capture options</legend>
      <div>
        <label for="minTimeOnSurface">Minimum time that is necessary to capture a signature in milliseconds:</label>
        <br>
        <input type="input" name="minTimeOnSurface" #minTimeOnSurface value="300">
      </div>
    </fieldset>
  </div>
</div>